export enum ColumnDataType {
	Integer = 'int',
	Float = 'float',
	Number = 'number',
	String = 'str',
	Datetime = 'datetime',
	Boolean = 'bool',
	Array = 'array',
}
